import { ViewModel } from '../view-model';
import { CONFIG } from '../../core/config';
import { EquipmentItem } from './equipment-item';

export class EquipmentSubUnit implements ViewModel, EquipmentItem {
  readonly friendlyTypeNameSingular = 'Equipment SubUnit';
  readonly apiRoute: string = CONFIG.apiRoutes.equipmentSubUnit;
  id: string;
  name: string;
  identifier: string;
  json() {
    return {
      id: this.id,
      name: this.name,
      identifier: this.identifier,
    };
  }

  public loadFromJson(data) {
    this.id = data.id;
    this.name = data.name;
    this.identifier= data.identifier;
  }
}
